import React from 'react';
import { Link, useHistory } from 'react-router-dom';

import './breadcrumbs.scss';

interface BreadcrumbsProps {
  icon?: any;
  items: { title: string; link: string }[];
  tabName?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ icon, items, tabName }) => {
  const history = useHistory();
  const renderBreadcrumbs = () =>
    items.map((item, index) => (
      <li key={`breadcrumb-${index}`} className="breadcrumbs__item">
        {item.link ? (
          <Link
            to={item.link}
            onClick={(e) => {
              e.preventDefault();
              history.push(item.link, { tabName });
            }}
          >
            {item.title}
          </Link>
        ) : (
          <span>{item.title}</span>
        )}
      </li>
    ));

  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs__icon">
        {typeof icon === 'string' ? (
          <img src={icon} className="icon " alt="Реестр" />
        ) : (
          icon
        )}
      </div>
      <ul className="breadcrumbs__list">{renderBreadcrumbs()}</ul>
    </div>
  );
};

export default Breadcrumbs;
